const HorizontalLine = () => {
  return <div className="border-b border-gray-300 my-4"></div>;
};

export default HorizontalLine;
